import {
  AppBase,
  baseFromDoc,
  FirestoreBaseDoc,
  makeDocConverter,
} from '../../base/firestore-model-base'
import type { Timestamp } from 'firebase/firestore'

/**
 * AdminAccount（管理者アカウント）
 *
 * - `AdminAccountDoc`: Firestore に保存される形（snake_case / Timestamp）
 * - `AdminAccount`: アプリで扱う形（camelCase / Date）
 * - `id` / `path` は AppBase で定義（documentId / document は廃止）
 */

export type AdminAccountDoc = FirestoreBaseDoc & {
  name_kanji: string
  name_kana: string
  email: string
  last_login_at?: Timestamp | null
}

export type AdminAccount = AppBase & {
  nameKanji: string
  nameKana: string
  email: string
  lastLoginAt?: Date
}

export const adminAccountDocConverter = makeDocConverter<AdminAccountDoc>()

export function toAdminAccount(id: string, doc: AdminAccountDoc, path: string): AdminAccount {
  const base = baseFromDoc(id, doc, path)
  return {
    ...base,
    nameKanji: doc.name_kanji,
    nameKana: doc.name_kana,
    email: doc.email,
    lastLoginAt: doc.last_login_at ? doc.last_login_at.toDate() : undefined,
  }
}

